import { header } from "../settings/__home";

export function TemplateAskAQuestion (form:any){

    return `
            <!DOCTYPE html>
            <html>
                <head>
                    <title></title>
                    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1">
                    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
                    <style type="text/css">
                    </style>
                </head>
                <body style="background-color: #f4f4f4; margin: 0 !important; padding: 0 0 80px 0 !important;">
                <!-- HIDDEN PREHEADER TEXT -->
                <div style="display: none; font-size: 1px; color: #fefefe; line-height: 1px; font-family: 'Lato', Helvetica, Arial, sans-serif; max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden;"> We're thrilled to have you here! Get ready to dive into your new account. </div>
                <table border="0" cellpadding="0" cellspacing="0" width="100%">
                    <tr>
                        <td align="center" class="mainColor">
                            <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                                <tr>
                                    <td align="center" valign="top" style="padding: 40px 10px 40px 10px;"></td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <!-- LOGO -->
                    <tr>
                        <td align="center" style="padding: 0px 10px 0px 10px;" class="mainColor">
                            <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                                <tr>
                                    <td bgcolor="#ffffff" align="center" valign="top" style="padding: 40px 20px 20px 20px; border-radius: 4px 4px 0px 0px; color: #111111; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 48px; font-weight: 400; letter-spacing: 4px; line-height: 48px;">
                                        <img src=${header.logoStore}" width="240" height="122" style="display: block; border: 0px;" />
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td bgcolor="#f4f4f4" align="center" style="padding: 0px 10px 0px 10px;">
                            <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">
                                <tr>
                                    <td bgcolor="#ffffff" align="left" style="padding: 20px 30px 40px 30px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;">
                                        <p style="margin: 0;">You have received a new email from the website with the data below</p>
                                    </td>
                                </tr>
                                <!-- Name -->
                                <tr>
                                    <td bgcolor="#ffffff" align="left" style="padding: 0px 30px 0px 30px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;">
                                        <p style="margin: 0; color: var(--principal); font-weight: 600;">Name:</p>
                                        <p id="xxx" style="margin: 0 0 10px 0;">${form.name}</p>
                                    </td>
                                </tr>
                                <!-- Email -->
                                <tr>
                                    <td bgcolor="#ffffff" align="left" style="padding: 0px 30px 0px 30px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;">
                                        <p style="margin: 0; color: var(--principal); font-weight: 600;">Email:</p>
                                        <p id="xxx" style="margin: 0 0 10px 0;">${form.email}</p>
                                    </td>
                                </tr>
                                <!-- Phone -->
                                <tr>
                                    <td bgcolor="#ffffff" align="left" style="padding: 0px 30px 0px 30px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;">
                                        <p style="margin: 0; color: var(--principal); font-weight: 600;">Phone:</p>
                                        <p id="xxx" style="margin: 0 0 10px 0;">${form.phone}</p>
                                    </td>
                                </tr>
        
                                <tr>
                                    <td bgcolor="#ffffff" align="left" style="padding: 0px 30px 0px 30px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;">
                                        <p style="margin: 0; color: var(--principal); font-weight: 600;">Message:</p>
                                        <p id="xxx" style="margin: 0 0 10px 0;">${form.message}</p>
                                    </td>
                                </tr>

                                <tr>
                                    <td bgcolor="#ffffff" align="left" style="padding: 0px 30px 0px 30px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;">
                                        <p style="margin: 0; color: var(--principal); font-weight: 600;">Url Product:</p>
                                        <p id="xxx" style="margin: 0 0 10px 0;">${form.url}</p>
                                    </td>
                                </tr>
                                <!--FOOTER-->
                                <tr>
                                    <td bgcolor="#ffffff" align="left" style="padding: 0px 30px 20px 30px; border-radius: 0px 0px 4px 4px; color: #666666; font-family: 'Lato', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; line-height: 25px;">
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr> 
                </table>
            </body>
        </html>
        `
    } 